import React from "react";
import Layout from '../../NewComponent/LayoutAdmin/Layout';
import AdminManageRole from "../../Component/AdminManageRole/AdminManageRole";
// import Index from '../../Component/Admin/managePermissions';
export default function ManageRole() {
  return (
    <>
      <Layout>
        <AdminManageRole />
      </Layout>
    </>
  );
}
      